import { inject, Injectable } from '@angular/core';
import { EEnvTypes } from '@common/enums/env-types.enum';
import { TranslationLoaderService } from '@common/services/translation-loader.service';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { environment } from '@web-env/environment';
import { CookieService } from 'ngx-cookie-service';

const SP_API_KEY =
    environment.type === EEnvTypes.STAGE
        ? 'AIzaSyBYiQUaXavZm_xebWcX51pvELaiXX0o-Gg'
        : 'AIzaSyAIdwJCNqJa0pExVq9R8pRESJqpL39016A';

@Injectable({
    providedIn: 'root',
})
export class CredentialsService {
    private readonly cookieService = inject(CookieService);

    constructor() {
        const lang = TranslationLoaderService.getCurrentLocale(this.cookieService);

        setOptions({
            key: SP_API_KEY,
            language: lang,
            region: 'UA',
        });
    }

    async loadMapsAPi(): Promise<void> {
        await Promise.all([importLibrary('places'), importLibrary('marker')]);
    }
}
